import * as React from 'react'
import * as Tooltip from 'react-tooltip'
import './TooltipWithIcon.scss'
import { makeRandomAlphaNumericString } from '../utilities/helpers'

interface Props {
  tooltipIconClassName?: string
  tooltipId?: string | null
  tooltipContent?: string | JSX.Element | JSX.Element[]
  tooltipProps?: any
  delayHide?: number
  allowHover?: boolean
  place?: string
  effect?: string
}

export const TooltipWithIcon = (props: Props) => {
  const { place, effect, tooltipIconClassName, tooltipContent, delayHide, allowHover } = props
  const tooltipId = props.tooltipId || makeRandomAlphaNumericString()

  return (
    <>
      <span
        className={tooltipIconClassName || 'fa fa-question-circle text-muted ml-2'}
        data-for={tooltipId}
        data-tip
      />
      <Tooltip
        id={tooltipId}
        place={place || 'right'}
        effect={effect || 'solid'}
        delayHide={delayHide}
        // This allows customers to click on a link inside a tooltip
        className={`${allowHover && 'tip-visible'}`}
      >
        <div>{tooltipContent}</div>
      </Tooltip>
    </>
  )
}
